import { connectRedux } from '@om1/platform-utils'
import { cohortBlocksEditActions, CohortState, CriterionNode } from '../../../state'
import { findNode } from '../../../state/edit/blocks/cohort-blocks-edit-reducer'
import { ObservationDateScoreEditDialogComponent } from './ObservationDateScoreEditDialogComponent'

export function createObservationDateScoreEditDialogComponent<TState extends { cohort: CohortState }>() {
    return connectRedux(
        ObservationDateScoreEditDialogComponent,
        (state: TState) => {
            const nodeId = state.cohort.edit.blocks.ui.observationScoreEditDialog.target.nodeId

            return {
                criteria: findNode(state.cohort.edit.blocks.tree, nodeId) as CriterionNode
            }
        },
        cohortBlocksEditActions
    )
}

export type ObservationDateScoreEditDialog = ReturnType<typeof createObservationDateScoreEditDialogComponent>
